import React, { useEffect } from "react";
import "./index.css";
import buttonArrow from "assets/realEstateCRM-image/button-arrow.svg";
import mobile from "assets/realEstateCRM-image/mobile.svg";
import smsIcon from "assets/realEstateCRM-image/sms.svg";
import fileIcon from "assets/realEstateCRM-image/file.svg";
import homeBanner from "assets/realEstateCRM-image/home_banner.png";
import homeBannerMobile from "assets/realEstateCRM-image/home_banner_mobile.png";
import customerService from "assets/realEstateCRM-image/customer_service.png";
import customerServiceMobile from "assets/realEstateCRM-image/customer_service_mobile.png";
import OurSolution from "../OurSolution/OurSolution";
import Benefit from "../Benefit/Benefit";
import NewUpdate from "../NewUpdate/NewUpdate";
import { useNavigate } from "react-router-dom";
import CRMTestimonial from "../CRMTestimonial/CRMTestimonial";
import Meta from "utils/meta";

function Index() {
  const navigate = useNavigate();

  const handleGetStart = (e) => {
    e.preventDefault();
    navigate("../choose-plan");
  };

  const handleGetDemo = (e) => {
    e.preventDefault();
    navigate("../request-a-demo");
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Meta title="Home | The Realtor Desk" description="" />
      <div className="realEstateCRM-container">
        <div className="content-details">
          <div className="container">
            <div className="realEstateCRM-head">
              <h1>
                Real Estate Team Dynamics <br /> Data-Driven CRM
              </h1>
              <p>
                Designed for real estate agencies of all sizes, The Realtor Desk
                CRM provides cutting-edge solutions for sales process management,
                property management, and automation. It caters to the needs of
                real estate agents, developers, and brokerage firms.
              </p>
            </div>
            <div className="tcl-homepage-hero__content-end tcl-button-group">
              <button onClick={handleGetDemo} className="tcl-button" type="button">
                <span>GET A DEMO</span>
              </button>
              <div onClick={handleGetStart} className="tcl-button--outer">
                <button className="tcl-button tcl-button--primary">GET START</button>
                <div className="realEstateCRM-arrow">
                  <img src={buttonArrow} alt="GET START" />
                </div>
              </div>
            </div>
            <div className="home-banner">
              <img className="mobile-banner--hide" src={homeBanner} alt="CRM: Real Estate Team Dynamics Data-Driven CRM" />
              <img className="mobile-banner--only" src={homeBannerMobile} alt="Real Estate Team Dynamics Data-Driven CRM" />
            </div>
          </div>
        </div>
        <div className="middle-section">
          <div className="container">
            <div className="content-col1">
              <h3>
                What is a real estate
                <br /> CRM software?
              </h3>
              <p>
                Real estate CRM software is a system that helps manage
                relationships between buyers, sellers, agents, brokers,
                developers, and financial institutions and caters to the
                multiple requirements of real estate agents and real estate
                firms. From managing incoming requests to preparing price
                quotes, from selling commercial real-estate to property
                management, the real estate CRM system takes care of the
                end-to-end process management for real estate agencies.
              </p>
              <p>&nbsp;</p>
              <h3>
                How is CRM important for
                <br />
                realtors?
              </h3>
              <p>
                Real estate is all about building trust, and it's no surprise
                that 82% of new property sales are referrals from either
                existing contacts, previous clients, family, friends, or
                relatives. Moreover, when it comes to real estate businesses,
                selling or buying is a long process, with many follow-ups and
                re-negotiations. In such scenarios, implementing a real estate
                CRM software gives realtors an efficient way to manage contacts,
                schedule tasks, monitor their pipelines, and stay organized to
                build successful relationships and close deals.
              </p>
            </div>
            <div className="customer-service">
              <img className="desktop-only" src={customerService} alt="CRM: What is a real estate CRM software?" />
              <img className="mobile-only" src={customerServiceMobile} alt="What is a real estate CRM software?" />
            </div>
          </div>
          <div className="why-choose--section">
            <div className="container">
              <h2>
                Why choose Realtor CRM for <br /> your real estate business?
              </h2>
              <div className="icon-container">
                <div className="icon-box">
                  <div className="iconOuter">
                    <img src={mobile} alt="no mobile icon" />
                  </div>
                  <div className="icons-head">
                    <h3>
                      Omnichannel <br /> Communication
                    </h3>
                  </div>
                </div>
                <div className="icon-box">
                  <div className="iconOuter">
                    <img src={smsIcon} alt="no mobile icon" />
                  </div>
                  <div className="icons-head">
                    <h3>
                      Built-in <br /> Campaigns
                    </h3>
                  </div>
                </div>
                <div className="icon-box">
                  <div className="iconOuter">
                    <img src={fileIcon} alt="no mobile icon" />
                  </div>
                  <div className="icons-head">
                    <h3>
                      Project <br /> Management
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <OurSolution />
        <CRMTestimonial />
        <Benefit />
        <NewUpdate />
      </div>
    </div>
  );
}

export default Index;
